import { STEPS_OPTIONS } from 'config/setup/constants';
import { StepsState } from './steps.types';

export const stepsInitialState: StepsState = {
    step: 0,
    steps: STEPS_OPTIONS,
};
